import { createContext, useState } from "react";

const FormContext = createContext({})

export const FormProvider = ({children}:any)=>{
    const [form, setForm] = useState({})
    const [postData, setPostData] = useState({})
    const [page, setPage] = useState(0)
    const [reload, setReload] = useState(false)

    return(
        <FormContext.Provider value={{form, setForm, postData, setPostData, page, setPage, reload, setReload}}>
            {children}
        </FormContext.Provider>
    )
}

export default FormContext